<template>
  <v-dialog
    scrollable
    v-model="isOpened"
    width="600px"
  >
    <v-card>
      <v-card-title>
        Envoyer un CR par email
        <v-spacer />
        <v-btn icon @click="isOpened = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-5">
        <v-text-field
          v-model="email"
          label="Email du destinataire"
          placeholder="Email du destinataire"
          persistent-placeholder
          outlined
          hide-details
          :error="isErrorEmail"
          class="mb-7"
        />
        <v-textarea
          v-model="message"
          label="Votre message"
          :placeholder="`Bonjour,\n\nVeuillez trouver ci-joint...`"
          persistent-placeholder
          outlined
          hide-details
          no-resize
          :error="isErrorMessage"
          height="350"
        />
      </v-card-text>
      <v-divider />
      <v-card-actions class="px-5 py-3">
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!$canWrite"
          type="submit"
          :loading="isSendingEmail"
          color="primary darken-1"
          class="px-4"
          @click="$canWrite && (sendEmail($event))"
        >
          Envoyer l'email
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from 'lodash';
import moment from 'moment';

export default {
  props: {
    value: Boolean,
    report: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isSendingEmail: false,
    isErrorEmail: false,
    isErrorMessage: false,
    email: ``,
    message: ``,
  }),
  computed: {
    isOpened: {
      get() { return this.value; },
      set(value) { this.$emit(`input`, value); },
    },
    ...mapState(`model/user`, [
      `me`,
    ]),
    userFullname() {
      return `${this.me.firstname} ${this.me.lastname}`;
    },
    reportDate() {
      return moment(this.report.createdAt).format(`DD/MM/YYYY`);
    },
    isEmailValid() {
      return this.$isEmail(this.email);
    },
    isMessageValid() {
      return _.trim(this.message) !== ``;
    },
  },

  methods: {
    ...mapActions(`model/interventionReport`, [
      `sendByEmail`,
    ]),
    initOpen() {
      this.email = ``;
      this.isSendingEmail = false;
      this.isErrorEmail = false;
      this.isErrorMessage = false;
      this.message = `
        Bonjour,

        Veuillez trouver ci-joint le compte-rendu de notre intervention du ${this.reportDate}.

        Cordialement,
        ${this.userFullname}
      `.replace(/^ */mg, ``).replace(/^\n/g, ``);
    },
    async sendEmail() {
      this.isErrorEmail = !this.isEmailValid;
      this.isErrorMessage = !this.isMessageValid;

      if (this.isErrorEmail || this.isErrorMessage || this.isSendingEmail) { return; }

      this.isSendingEmail = true;

      const success = await this.sendByEmail({
        reportId: this.report.id,
        email: this.email,
        message: this.message,
      });

      if (success) {
        this.$store.dispatch(`showSnackbar`, {
          color: `success`,
          message: `Compte-rendu envoyé par email`,
        });
      } else {
        this.$store.dispatch(`showSnackbar`, {
          color: `error`,
          message: `Impossible d'envoyer cet email`,
        });
      }

      this.isSendingEmail = false;
      this.isOpened = !success;
      // this.isSendingEmail = true;
    },
  },

  watch: {
    isOpened(isOpened) {
      if (isOpened) {
        this.initOpen();
      }
    },
  },
};
</script>
